import React from 'react';
import Select from 'react-select';
import { Button, Modal, Table, Radio, Dropdown } from 'semantic-ui-react';
import debounce from '../../../../utils/debounce';
import {
  ReplaceButtonBlock,
  SearchDishBlock,
  SearchDishBlockLabel,
  RecommendedDishBlock,
  RecommendedDishTitle,
  RecommendedDishText,
  DontRemmemberText,
} from './DishReplaceModalStyles';
import { defualt_portion } from '../../youslim2.0_Constants';

const defaultChooseDish = 0;

const DishReplaceModal = ({
  isOpen,
  replaceDish = [],
  onClose,
  onReplaceDish,
  getDishListByName,
  dishes,
}) => {
  const [dishList, setDishList] = React.useState([0]);
  const [chooseDish, setChooseDish] = React.useState(0);
  const [dropdownDish, setDropdownDish] = React.useState('');
  const [portionsName, setPortionsName] = React.useState('small');
  const [portionsId, setPortionsId] = React.useState(1);

  const onChooseDish = (chooseDish) => {
    setChooseDish(chooseDish);
  };

  const onChangeDish = (dish) => {
    setDropdownDish(dish);
  };

  const onChangePortion = (data) => {
    setPortionsName(data.value);
    defualt_portion.forEach((portion) => {
      if (data.value === portion.value) setPortionsId(portion.key);
    });
  };

  const onSearchProduct = (value) => {
    getDishListByName(value);
  };

  React.useEffect(() => {
    const newDishes = [];
    dishes.forEach((dish) => {
      newDishes.push({ label: dish.title, value: dish.title, id: dish.id });
    });

    setDishList(newDishes);
  }, [dishes]);

  React.useEffect(() => {
    getDishListByName();
  }, []);

  return (
    <Modal
      style={{ alignSelf: 'center' }}
      open={isOpen}
      centered
      size="medium"
      closeIcon
      onClose={onClose}
    >
      <Modal.Header style={{ textAlign: 'center' }}>
        <p>Замена блюда</p>
      </Modal.Header>

      <Modal.Content>
        <SearchDishBlock>
          <Radio
            name="radioGroup"
            value={defaultChooseDish}
            checked={chooseDish === defaultChooseDish}
            onChange={() => onChooseDish(defaultChooseDish)}
          />
          <SearchDishBlockLabel>Поиск блюда</SearchDishBlockLabel>
          <Select
            placeholder="Выберите продукт"
            // id="choose-product-input"
            fluid
            search
            selection
            clearable
            options={dishList}
            value={dropdownDish}
            onInputChange={debounce(onSearchProduct, 1000)}
            onChange={onChangeDish}
          />
          <Dropdown
            placeholder="Выберите порцию"
            // id="choose-product-input"
            fluid
            selection
            style={{ maxWidth: 120 }}
            options={defualt_portion}
            value={portionsName}
            onChange={(e, data) => onChangePortion(data)}
          />
        </SearchDishBlock>
        <DontRemmemberText>*Не забудьте указать размер порции</DontRemmemberText>
        <Table definition celled>
          <Table.Header>
            <Table.Row>
              <Table.HeaderCell>
                <RecommendedDishTitle>Или замените на рекомендованное:</RecommendedDishTitle>
              </Table.HeaderCell>
            </Table.Row>
          </Table.Header>
          <Table.Body>
            {replaceDish.map((product, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Table.Row key={product.product_id + index}>
                <Table.Cell>
                  <RecommendedDishBlock>
                    <Radio
                      name="radioGroup"
                      value={product.id}
                      checked={chooseDish === product.id}
                      onChange={() => onChooseDish(product.id)}
                    />
                    <RecommendedDishText>{product.title}</RecommendedDishText>
                  </RecommendedDishBlock>
                </Table.Cell>
              </Table.Row>
            ))}
          </Table.Body>
        </Table>
        <ReplaceButtonBlock>
          {chooseDish === 0 ? (
            <Button color="green" onClick={() => onReplaceDish(dropdownDish.id, portionsId)}>
              Заменить на выбранное
            </Button>
          ) : (
            <Button color="green" onClick={() => onReplaceDish(chooseDish)}>
              Заменить на выбранное
            </Button>
          )}
          <Button onClick={onClose}>Отмена</Button>
        </ReplaceButtonBlock>
      </Modal.Content>
    </Modal>
  );
};

export default DishReplaceModal;



// WEBPACK FOOTER //
// ./src/Components/YouSlim2.0/NutritionCourse/DishReplaceModal/index.jsx